import Box from '@mui/material/Box';
import Skeleton from '@mui/material/Skeleton';
import Stack from '@mui/material/Stack';

/** Header, indicators and the two columns while the integration loads. */
const IntegrationSkeleton = () => (
  <Stack gap={3} aria-busy="true">
    <Skeleton variant="text" width="30%" height={40} />
    <Box
      sx={{
        display: 'grid',
        gap: 2,
        gridTemplateColumns: { xs: 'repeat(2, 1fr)', md: 'repeat(4, 1fr)' },
      }}
    >
      {Array.from({ length: 4 }, (_, index) => (
        <Skeleton key={index} variant="rounded" height={104} />
      ))}
    </Box>
    <Box
      sx={{
        display: 'grid',
        gap: 3,
        gridTemplateColumns: { xs: 'minmax(0, 1fr)', md: 'minmax(0, 2fr) minmax(0, 1fr)' },
      }}
    >
      <Skeleton variant="rounded" height={420} />
      <Skeleton variant="rounded" height={240} />
    </Box>
  </Stack>
);

export default IntegrationSkeleton;
